import React, { useState } from 'react';

import { Radio, RadioOption } from '../../../../components/radio/Radio';

import { MobileDialog } from 'features/search/components/MobileDialog';

import { createStyle } from 'utils/createStyle';
import { SortByProps, SortByOption } from 'features/search/components/SortBy';

const btnStyle = createStyle(
    'mt-8 py-1 px-10 w-full rounded-3xl bg-brand text-white font-semibold',
    {
        maxWidth: 280,
    }
);

export const MobileSortView = ({
    options,
    sortedByField,
    onChange = () => null,
}: Partial<SortByProps>) => {
    const [selectedField, setSelectedField] = useState(sortedByField);

    const onApplyClicked = () => {
        onChange(selectedField as SortByOption);
    };

    const footer = (onClick: React.MouseEventHandler) => (
        <button className={btnStyle} onClick={onClick}>
            Sort
        </button>
    );

    return (
        <MobileDialog
            btnName="Sort"
            header="Sort"
            footer={footer}
            styles={{ container: 'border-r-0' }}
            onApply={onApplyClicked}
        >
            <Radio
                options={options as RadioOption[]}
                onChange={(option: SortByOption) => setSelectedField(option)}
                value={selectedField?.value ?? ''}
            />
        </MobileDialog>
    );
};
